import React from "react"
import enhanceWithClickOutside from "react-click-outside"
import Keyboard from "./discount-keyboard"

class DiscountModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showKeyboard: false,
      amountDiscount: true
    };
    this.handleAmount = this.handleAmount.bind(this);
    this.handlePercentage = this.handlePercentage.bind(this);
    this.handleRequestClose = this.handleRequestClose.bind(this);
  }

  handleClickOutside(e) {
    e.stopPropagation()
    this.props.onRequestClose()
  }

  handleAmount() {
    this.setState({showKeyboard: true})
  }

  handlePercentage() {
    this.setState({showKeyboard: true, amountDiscount: false})
  }

  handleRequestClose(e) {
    e.stopPropagation()
    this.setState({showPKeyboard: false, amountDiscount: true})
    this.props.onRequestClose()
  }

  handlePreset(e, amount) {
    this.props.onSetDiscount({type: 'percentage', amount: amount})
    this.handleRequestClose(e)
  }

  render() {
    const options = () => {
      return (
        <div className="shop-cart__discount-modal_options">
          <div className="shop-cart__discount-modal_options_item"
               onClick={this.handleAmount}>
            <div>Set Amount</div>
            <div>&gt;</div>
          </div>
          <div className="shop-cart__discount-modal_options_item"
               onClick={this.handlePercentage}>
            <div>Set Percentage</div>
            <div>&gt;</div>
          </div>
          <div className='shop-cart__preset-percentage'>
            <div className='preset' onClick={(e) => this.handlePreset(e, 25)}>25%</div>
            <div className='preset' onClick={(e) => this.handlePreset(e, 50)}>50%</div>
            <div className='preset' onClick={(e) => this.handlePreset(e, 100)}>100%</div>
          </div>
        </div>
      )
    }
    return (
        <div style={this.props.styles} className={`shop-cart__discount-modal
          ${this.state.showKeyboard ?
            'shop-cart__discount-modal-keyboard' : 'shop-cart__discount-modal-option'}`}>
          {this.state.showKeyboard ?
            <Keyboard onSetDiscount={this.props.onSetDiscount}
                    onCorrectDiscount={this.props.onCorrectDiscount}
                    onRequestClose={this.handleRequestClose}
                    type={this.state.amountDiscount ? "amount" : "percentage"}
            /> :
            options() }
          <span></span>
        </div>
    )
  }
}

export default enhanceWithClickOutside(DiscountModal)
